import {ServerResponse, ReportingNetService, ReportType} from '@spa/api';

import { ReportsService } from '@spa/reporting';

import { environment } from 'appEnv/environment';
import { Helper } from 'appShared/classes';
import { ReportTypesEnum } from '../../enums';

export class PanelReportsAccountsTrait {
    static getAccountReport(
        reportType: number,
        account: string,
        dateFrom: string,
        dateTo: string,
        reportingNetService: ReportingNetService,
        reportsService: ReportsService,
        currency?: string
    ): ServerResponse<ReportType> {
        switch (reportType) {
            case ReportTypesEnum.Trades:
                return reportsService.getAccountTradesReport(account, dateFrom, dateTo, currency);
            case ReportTypesEnum.Adjustments:
                return reportingNetService.getAccountAdjustmentsReport(account, dateFrom, dateTo, currency);
            case ReportTypesEnum.OpenPositions:
                return reportingNetService.getAccountOpenPositionsReport(account, dateFrom, dateTo, currency);
            case ReportTypesEnum.Detailed:
                return reportingNetService.getAccountDetailedReport(account, dateFrom, dateTo, currency);
            case ReportTypesEnum.TotalsBySymbol:
                return reportingNetService.getAccountTotalsBySymbolReport(account, dateFrom, dateTo, currency);
            case ReportTypesEnum.TotalsByDate:
                return reportingNetService.getAccountTotalsByDateReport(account, dateFrom, dateTo, currency);
            case ReportTypesEnum.SummaryByDate:
                return reportingNetService.getAccountSummaryByDateReport(account, dateFrom, dateTo, currency);
            case ReportTypesEnum.FeesByDestination:
                return reportingNetService.getAccountFeesByDestinationReport(account, dateFrom, dateTo, currency);
        }
    }

    static getGroupReports(
        reportType: number,
        accountGroupReferenceId: string,
        dateFrom: string,
        dateTo: string,
        reportingNetService: ReportingNetService,
        currency?: string
    ): ServerResponse<ReportType> {
        switch (reportType) {
            case ReportTypesEnum.GroupAdjustments:
                return reportingNetService.getGroupAdjustmentsReport(accountGroupReferenceId, dateFrom, dateTo, currency);
            case ReportTypesEnum.GroupTotalsBySymbol:
                return reportingNetService.getGroupTotalsBySymbolReport(accountGroupReferenceId, dateFrom, dateTo, currency);
            case ReportTypesEnum.GroupOpenPositions:
                return reportingNetService.getGroupOpenPositionsReport(accountGroupReferenceId, dateFrom, dateTo, currency);
            case ReportTypesEnum.TotalsByGroup:
                return reportingNetService.getGroupTotalsByGroupReport(
                    Helper.formatDate(dateFrom, environment.dateFormatLocalDate),
                    Helper.formatDate(dateTo, environment.dateFormatLocalDate), currency);
            case ReportTypesEnum.TotalsByAccount:
                return reportingNetService.getGroupTotalsByAccountsReport(accountGroupReferenceId, dateFrom, dateTo, currency);
            case ReportTypesEnum.GroupSummaryByDate:
                return reportingNetService.getGroupSummaryByDateReport(accountGroupReferenceId, dateFrom, dateTo, currency);
            case ReportTypesEnum.GroupFeesByDestination:
                return reportingNetService.getGroupFeesByDestinationReport(accountGroupReferenceId, dateFrom, dateTo, currency);
        }
    }
}
